import { render, staticRenderFns } from "./SectionReviews.vue?vue&type=template&id=aa334828&scoped=true&"
import script from "./SectionReviews.vue?vue&type=script&lang=ts&"
export * from "./SectionReviews.vue?vue&type=script&lang=ts&"
import style0 from "./SectionReviews.vue?vue&type=style&index=0&id=aa334828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa334828",
  null
  
)

export default component.exports